import { useDirtyStateGuard, type DirtyStateGuardProps } from './useDirtyStateGuard.js';

/** Spec1-P12 DirtyStateGuard — mount while a form is dirty to enforce leave-warn. */
export function DirtyStateGuard({ when, title, message }: DirtyStateGuardProps): null {
  useDirtyStateGuard(when, { title, message });
  return null;
}

DirtyStateGuard.displayName = 'DirtyStateGuard';
